import React from "react";
import { SvgIconProps } from "./SvgIconProps";

export const CheckSvg: React.FC<SvgIconProps> = ({ sizeCx }) => {
  return (
    <svg
      width={"20"}
      height={"20"}
      viewBox={"0 0 20 20"}
      fill={"none"}
      xmlns={"http://www.w3.org/2000/svg"}
      className={`inline-block ${sizeCx} fill-current stroke-current`}>
      <path
        d={
          "M8.33408 12.6427L15.9944 4.98242L17.1729 6.16093L8.33408 14.9997L3.03076 9.69649L4.20927 8.51799L8.33408 12.6427Z"
        }
        fill={"currentColor"}
      />
    </svg>
  );
};
